import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../../../../../../components/buttons/Button';
import Spinner from '../../../../../../components/loaders/Spinner';

import './ImageSearchLoadMoreButton.scss';

const ImageSearchLoadMoreButton = ({ loading, handleFetchMore }) => (
    <li className="ImageSearchLoadMoreButton">
        {loading ? <Spinner show /> : <Button onClick={handleFetchMore}>Load more</Button>}
    </li>
);

ImageSearchLoadMoreButton.propTypes = {
    loading: PropTypes.bool,
    handleFetchMore: PropTypes.func,
};

export default ImageSearchLoadMoreButton;
